import Head from 'next/head';
import { memo } from 'react';

import { type UseDocumentTitleParams, useDocumentTitle } from '~/hooks/useDocumentTitle';

export type DocumentTitleProps = UseDocumentTitleParams;

const IS_SERVER = typeof window === 'undefined';

/**
 * Registers a tab title with `DocumentTitleHead`. Effects do not run on the server, so the title is also
 * rendered into the server HTML there. On the client only `DocumentTitleHead` emits `<title>`.
 */
export const DocumentTitle = memo(({ title, isFallback, isPending }: DocumentTitleProps) => {
  useDocumentTitle({ title, isFallback, isPending });

  if (!IS_SERVER || isFallback || !title) {
    return null;
  }

  return (
    <Head>
      <title key="title">{title}</title>
    </Head>
  );
});

DocumentTitle.displayName = 'DocumentTitle';
